export default __webpack_public_path__ + "static/media/store.1f0ef1fa.svg";